<template>
  <div class="logins-wrapper">
    <div class="wrapper">
      <img @click='goBack' class="goback" src="../../../static/images/goback.png" alt="">
      <p class="psd_guid">重置密码</p>
      <div class="box right">
        <div class="name">
          <input placeholder="新密码" type="password" name="user_name" id="tel" v-model='user_name' @keyup='checkIfCanLogin'>
        </div>
        <div class="pass">
          <input placeholder="确认新密码" type="password" name="password" id="pass" v-model='user_psd' @keyup='checkIfCanLogin'>
        </div>
        <div class="r-bot">
          <button class="login" id="login" :disabled='disabledFlag' @click='changepwd' :class="{disabled:disabledFlag}">重置密码</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";

export default {
  data() {
    return {
      user_name: '',
      user_psd: '',
      disabledFlag: true,
    };
  },
  mounted() {
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 检测是否可登录
    checkIfCanLogin () {
      if ($('#tel').val().length > 0 && $('#pass').val().length > 0){
        this.disabledFlag = false
      } else {
        this.disabledFlag = true
      }
    },
    // 更改密码
    changepwd () {
      if ($('#tel').val().length > 5 && $('#tel').val().length < 21) {
        if (this.user_name == this.user_psd) {
          this.$api.CHANGEPWD({
            'offcn-ticket': this.$route.query.code,
            username: this.$route.query.phone,
            password: this.user_psd
          }).then(res => {
            if (res.code == 0) {
              Toast(res.message)
              this.$router.push({ path: "/" })
            } else {
              Toast("请输入正确的验证码")
            }
          })
        } else {
          Toast("两次密码不一致")
        }
      } else {
        Toast("请输入6-20位的密码")
      }
    }
  }
};
</script>

<style lang="less" scoped>
.logins-wrapper {
  height: 100%;
  background: #ffffff;
  .wrapper {
    padding: 60px;
    height: 100%;
    background: url(./static/images/login_bg.jpg) no-repeat top center;
    background-size: cover;
    .goback {
      width: 12px;
      height: 28px;
    }
    .psd_guid {
      font-size: 42px;
      font-weight: bold;
      margin-top: 100px;
    }
  }
}
.box {
  margin-top: 120px;
  .name,.pass {
    position: relative;
    display: flex;
    align-items: center;
    input{
      width: 100%;
      height: 90px;
      outline: none;
      font-size: 28px;
      position: relative;
      border: none;
      border-bottom: 1px solid #cccccc;
      background: transparent;
    }
  }
  .pass {
    margin-top: 15px;
  }
  .r-bot {
    margin-top: 60px;
    .login{
      width: 100%;
      height: 100px;
      border: none;
      color: #ffffff;
      font-size: 36px;
      background: #e60012;
      border-radius: 50px;
      &.disabled {
        background: #e89692;
      }
    }
    .usual_problem {
      color: #666666;
      font-size: 26px;
      margin-top: 50px;
      .reset_psd {
        float: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/verificationCode/changepwd.vue